import { Route } from "vue-router";

import listPageUrlParser from "@/lib/services/list-page-url-parser.function";
import listItemPageUrlParser from "@/lib/services/list-item-page-url-parser.function";

import FactoryRushCapacityManagementPage from "./components/ManagementPage.vue";
import FactoryRushCapacityEditPage from "./components/EditPage.vue";
import FactoryRushCapacityProductGroupAddPage from "./components/ProductGroup/AddPage.vue";
import FactoryRushCapacityProductGroupEditPage from "./components/ProductGroup/EditPage.vue";
import FactoryRushCapacityProductGroupsListPage from "./components/ProductGroup/ListPage.vue";

export default [
  {
    path: "/factory_rush_capacity/manage",
    name: "FactoryRushCapacityManagementPage",
    component: FactoryRushCapacityManagementPage,
    meta: {
      auth: true,
    },
  },
  {
    path: "/factory_rush_capacity/edit",
    name: "FactoryRushCapacityEditPage",
    component: FactoryRushCapacityEditPage,
    props: (route: Route): Record<string, unknown> => {
      const props = listItemPageUrlParser(route);

      if (typeof route.query.id === "string") {
        props["factoryId"] = route.query.id;
      }

      return props;
    },
    meta: {
      auth: true,
    },
  },
  {
    path: "/factory_rush_capacity/product_group/list",
    name: "FactoryRushCapacityProductGroupsListPage",
    component: FactoryRushCapacityProductGroupsListPage,
    props: (route: Route): Record<string, unknown> => listPageUrlParser(route),
    meta: {
      auth: true,
    },
  },
  {
    path: "/factory_rush_capacity/product_group/add",
    name: "FactoryRushCapacityProductGroupAddPage",
    component: FactoryRushCapacityProductGroupAddPage,
    props: (route: Route): Record<string, unknown> =>
      listItemPageUrlParser(route),
    meta: {
      auth: true,
    },
  },
  {
    path: "/factory_rush_capacity/product_group/edit",
    name: "FactoryRushCapacityProductGroupEditPage",
    component: FactoryRushCapacityProductGroupEditPage,
    props: (route: Route): Record<string, unknown> => {
      const props = listItemPageUrlParser(route);

      if (typeof route.query.id === "string") {
        props["groupId"] = route.query.id;
      }

      return props;
    },
    meta: {
      auth: true,
    },
  },
];
